//@flow
import * as React from 'react';
import { deriveSlotType } from 'common/entity/components/multiDaySlot/TimeSlotsSelectorModalContainer';
import slotsSummaryFactory from 'common/entity/components/slot/SlotsSummaryFactory';

import type { MultiDaySlot } from 'common/models/internal/MultiDaySlot';
import DateTimeUtils, {
    DateInputFormats,
    TimeStyle
} from 'common/utils/DateTimeUtils';
type Props = {
    theme: Object,
    data: MultiDaySlot
};

export class SummaryComponent extends React.PureComponent<Props> {
    render() {
        const { data: multiDaySlot, theme, t } = this.props;
        const { slots } = multiDaySlot;
        if (slots.size) {
            const slotElements = slots.map((slot, index) => {
                const start = DateTimeUtils.format(
                    slot.start,
                    {
                        timeStyle: TimeStyle.SHORT
                    },
                    DateInputFormats.HOUR24_SHORT
                );
                const end = DateTimeUtils.format(
                    slot.end,
                    {
                        timeStyle: TimeStyle.SHORT
                    },
                    DateInputFormats.HOUR24_SHORT
                );
                return (
                    <span key={index}>
                        {t('slotStartToEnd', {
                            start,
                            end
                        })}
                    </span>
                );
            });
            return <div className={theme.slots}>{slotElements}</div>;
        }
        return <span> - </span>;
    }
}

const TimeSlotsSummaryComponent = slotsSummaryFactory({ SummaryComponent });
const TimeSlotsSummary = props => {
    return (
        <TimeSlotsSummaryComponent {...props} deriveSlotType={deriveSlotType} />
    );
};
export { TimeSlotsSummary };
export default TimeSlotsSummary;
